"use client";

const TEAM_COOKIE_ENDPOINT = "/api/team-cookie";

export async function persistTeamCookie(teamId: string) {
  if (!teamId) return;

  try {
    await fetch(TEAM_COOKIE_ENDPOINT, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ teamId }),
    });
  } catch (error) {
    console.error("Failed to persist team cookie", error);
  }
}
